import './Incoming.css'
import '../Styles.css'
import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useToast } from '../../contexts/ToastContext'

import EnquiryAddFields from '../../components/FormComps/Incoming/EnquiryAddFields'
import AddSiteForm from '../../components/FormComps/Sites/AddSiteForm'

import {
  postEnquiryTypes,
  dropDown,
} from '../../data/interfaces'

import { submitEnquiry } from '../../data/enquiryData'
import {
  updateClient,
  submitClient,
  getTargetClient,
} from '../../data/clientData'
import { submitSite } from '../../data/siteData'

import {
  Drawer,
  DrawerContent,
  DrawerNavigation,
} from '@progress/kendo-react-layout'

import { getTargetClientByPhone } from '../../data/clientData'
import { FaTimesCircle } from 'react-icons/fa'
import AccountForm from '../../components/FormComps/Accounts/AccountForm'
import { getAddressesForClientDropdown, getClientsForClientsDropdown } from '../../data/accountsData'

const Incoming = () => {
  const [touchedClient, setTouchedClient] = useState(false)
  const [newClient, setNewClient] = useState(false)

  const { showToast } = useToast()
  const navigate = useNavigate()

  //Set up an object to hold the form state
  const [formState, setFormState] = useState({
    partialMatch: false,
    clientId: 0,
    contactId: 0,
    clientName: '',
    accountRef: '',
    contactFirstName: '',
    contactLastName: '',
    phone: '',
    email: '',
    clientAddr: '',
    postcode: '',
    phone2: '',
    fax: '',
    tradeContact: '',
    email2: '',
    email3: '',
    websiteUrl: '',
    vatNum: '',
    directdebitEmail: '',
    siteId: 0,
    siteAddr: '',
    sitePostcode: '',
    possibleClient: false,
    possibleSite: false,
    openEnquiries: 0,
    openQuotes: 0,
    openJobs: 0,
  })

  const [loading, setLoading] = useState(true)
  const { phoneNumber } = useParams()
  const [number, setNumber] = useState(phoneNumber as string)
  const [expanded, setExpanded] = useState(false)
  const [siteAddr, setSiteAddr] = useState({ text: '', value: 0 })
  const [contact, setContact] = useState({ text: '', value: 0 })
  const [siteData, setSiteData] = useState<dropDown[]>([])
  const [clientId, setClientId] = useState(0)

  const handleExpanded = () => {
    setExpanded((prevState) => !prevState)
  }

  const handleSelect = () => {
    setExpanded(false)
  }

  useEffect(() => {
    setNumber(phoneNumber as string)
  }, [phoneNumber])

  useEffect(() => {
    const fetchClientData = async () => {
      const client = await getTargetClientByPhone(number as string)
      setFormState({
        contactId: client.contactId,
        openJobs: client.matchingClient.openJobs,
        openEnquiries: client.matchingClient.openEnquiries,
        openQuotes: client.matchingClient.openQuotes,
        partialMatch: client.partialMatch,
        clientId: client.matchingClient.clientId,
        clientName: client.matchingClient.clientName,
        accountRef: client.matchingClient.accountRef,
        contactFirstName: client.matchingClient.contactFirstName,
        contactLastName: client.matchingClient.contactLastName,
        phone: client.matchingClient.phone,
        email: client.matchingClient.email,
        clientAddr: client.matchingClient.clientAddr,
        postcode: client.matchingClient.postcode,
        phone2: client.matchingClient.phone2,
        fax: client.matchingClient.fax,
        tradeContact: client.matchingClient.tradeContact,
        email2: client.matchingClient.email2,
        email3: client.matchingClient.email3,
        websiteUrl: client.matchingClient.websiteUrl,
        vatNum: client.matchingClient.vatNum,
        directdebitEmail: client.matchingClient.directdebitEmail,
        siteId: client.matchingSite.siteId,
        siteAddr: client.matchingSite.siteAddr,
        sitePostcode: client.matchingSite.postcode,
        possibleClient: client.possibleClients.disabled,
        possibleSite: client.possibleSites.disabled,
      })
      if (client.partialMatch) {
        setNewClient(false)
      } else {
        setNewClient(true)
      }
      setLoading(false)
    }

    fetchClientData()
  }, [number])

  const [enquiryData, setEnquiryData] = useState<postEnquiryTypes>({
    clientId: formState.clientId,
    siteId: 0,
    priorityId: 0,
    enquirysourceId: 0,
    description: '',
    employeeAssignedToId: 0,
    contactId: 0
  })

  const handleFormState = (field: any, value: string) => {
    setFormState((prevState) => {
      return {
        ...prevState,
        [field]: value,
      }
    })
  }

  const handleEnquiryData = (field: any, value: number) => {
    setEnquiryData((prevState) => {
      return {
        ...prevState,
        [field]: value,
      }
    })
  }

  const newEnquiryHandler = () => {
    const enquiryObj = {
      clientId: formState.clientId,
      siteId: enquiryData.siteId,
      priorityId: 1,
      enquirysourceId: enquiryData.enquirysourceId,
      description: enquiryData.description,
      employeeAssignedToId: enquiryData.employeeAssignedToId,
      contactId: enquiryData.contactId
    }
    submitEnquiry(enquiryObj).then(() => {
      navigate('/enquiries')
    })
    showToast('Enquiry successfully added', 'success')
  }

  const updateClientHandler = (data: any, id: number) => {
    const clientObj = {
      contactId: data.contactId,
      openJobs: data.openJobs,
      openEnquiries: data.openEnquiries,
      openQuotes: data.openQuotes,
      clientId: data.clientId,
      clientName: data.clientName,
      accountRef: data.accountRef,
      contactName: data.contactFirstName + ' ' + data.contactLastName,
      phone: data.phone,
      email: data.email,
      clientAddr: data.clientAddr,
      postcode: data.postcode,
      phone2: data.phone2,
      fax: data.fax,
      tradeContact: data.tradeContact,
      email2: data.email2,
      email3: data.email3,
      websiteUrl: data.websiteUrl,
      vatNum: data.vatNum,
      directdebitEmail: data.directdebitEmail,
    }
    updateClient(clientObj, id)
    showToast('Client successfully updated', 'success')
  }

  const newClientHandler = (data: any) => {
    const clientObj = {
      contactId: data.contactId,
      openJobs: data.openJobs,
      openEnquiries: data.openEnquiries,
      openQuotes: data.openQuotes,
      clientName: data.clientName,
      accountRef: data.accountRef ? data.accountRef : null,
      contactName: data.contactFirstName + ' ' + data.contactLastName,
      phone: data.phone,
      email: data.email ? data.email : null,
      clientAddr: data.clientAddr,
      postcode: data.postcode,
      phone2: data.phone2 ? data.phone2 : null,
      fax: data.fax ? data.fax : null,
      tradeContact: data.tradeContact ? data.tradeContact : null,
      email2: data.email2 ? data.email2 : null,
      email3: data.email3 ? data.email3 : null,
      websiteUrl: data.websiteUrl ? data.websiteUrl : null,
      vatNum: data.vatNum ? data.vatNum : null,
      directdebitEmail: data.directdebitEmail ? data.directdebitEmail : null,
    }
    submitClient(clientObj).then((data) => {
      setFormState({
        contactId: data.contactId || 0,
        openJobs: data.openJobs,
        openEnquiries: data.openEnquiries,
        openQuotes: data.openQuotes,
        partialMatch: formState.partialMatch,
        clientId: data.clientId,
        clientName: data.clientName,
        accountRef: data.accountRef,
        contactFirstName: data.contactName.split(' ')[0],
        contactLastName: data.contactName.split(' ')[1],
        phone: data.phone,
        email: data.email,
        clientAddr: data.clientAddr,
        postcode: data.postcode,
        phone2: data.phone2,
        fax: data.fax,
        tradeContact: data.tradeContact,
        email2: data.email2,
        email3: data.email3,
        websiteUrl: data.websiteUrl,
        vatNum: data.vatNum,
        directdebitEmail: data.directdebitEmail,
        siteId: formState.siteId,
        siteAddr: formState.siteAddr,
        sitePostcode: data.postcode,
        possibleClient: false,
        possibleSite: false,
      })
      showToast('Client successfully added', 'success')
    })
  }

  const newSiteHandler = (dataItem: any) => {
    const siteObj = {
      siteAddr: dataItem.siteAddr,
      postcode: dataItem.postcode,
    }
    submitSite(siteObj).then((data) => {
      setFormState({
        ...formState,
        siteAddr: data.siteAddr,
      })
    })
    handleExpanded()
    showToast('Site successfully added', 'success')
  }

  const newSiteHandlerFromClient = (dataItem: any) => {
    const siteObj = {
      siteAddr: dataItem.siteAddr,
      postcode: dataItem.postcode,
    }
    submitSite(siteObj).then((data) => {
      setFormState({
        ...formState,
        siteAddr: data.siteAddr,
      })
    })
    showToast('Site successfully added', 'success')
  }

  const handleClientChange = (clientId: number) => {
    const fetchClientData = async (id: number) => {
      const client = await getTargetClient(id)
      setFormState({
        ...formState,
        clientId: client.clientId,
        clientName: client.clientName,
        accountRef: client.accountRef,
        contactFirstName: client.contactFirstName,
        contactLastName: client.contactLastName,
        phone: client.phone,
        email: client.email,
        clientAddr: client.clientAddr,
        postcode: client.postcode,
        phone2: client.phone2,
        fax: client.fax,
        tradeContact: client.tradeContact,
        email2: client.email2,
        email3: client.email3,
        websiteUrl: client.websiteUrl,
        vatNum: client.vatNum,
        directdebitEmail: client.directdebitEmail,
      })
    }

    fetchClientData(clientId)
  }

  const handleSubmit = () => {
    if (
      enquiryData.siteId === 0 ||
      enquiryData.description === '' ||
      enquiryData.contactId === 0
    ) {
      showToast('Please fill out the required enquiry fields', 'error')
      return
    }
    if (touchedClient) {
      updateClientHandler(formState, formState.clientId)
    }
    newEnquiryHandler()
  }

  const getAndStoreAddressesForCustomer = async (customerId: number) => {
    try {
      const res = await getAddressesForClientDropdown(customerId);
      setSiteData(res);
      setSiteAddr({
        text: res.length === 1 ? res[0]?.text || '' : '',
        value: res.length === 1 ? res[0]?.value || 0 : 0,
      });
      if (res.length === 1) {
        setEnquiryData((prev: any) => ({
          ...prev,
          siteId: res[0]?.value || 0,
        }))
        setFormState((prev: any) => ({
          ...prev,
          siteId: res[0]?.value || 0,
        }))
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (formState.clientId !== 0) {
      getAndStoreAddressesForCustomer(formState.clientId);
    }
  }, [formState.clientId])

  const [contactsForClient, setContactsForClient] = useState<dropDown[]>([]);

  const getAndStoreContactsForCustomer = async (customerId: number) => {
    try {
      const res = await getClientsForClientsDropdown(customerId);
      setContactsForClient(res);
      setContact((prev: any) => ({
        text: res.length === 1 ? res[0]?.text || '' : '',
        value: res.length === 1 ? res[0]?.value || 0 : 0,
      }))
      if (res.length === 1) {
        setEnquiryData((prev: any) => ({
          ...prev,
          contactId: res[0]?.value || 0,
        }))
        setFormState((prev: any) => ({
          ...prev,
          contactId: res[0]?.value || 0,
        }))
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (formState.clientId !== 0) {
      getAndStoreContactsForCustomer(formState.clientId);
    }
  }, [formState.clientId])

  useEffect(() => {
    if (clientId !== 0) {
      setFormState((prev: any) => ({
        ...prev,
        clientId: clientId
      }))
    }
  }, [clientId]);

  return (
    <Drawer
      expanded={expanded}
      position={'end'}
      width={900}
      mode='overlay'
      animation={false}
      onOverlayClick={handleExpanded}
      onSelect={handleSelect}
    >
      <DrawerContent>
        <DrawerNavigation>
          <div className='form__title__container'>
            <h1 className='form__title'>Add Site</h1>
            <FaTimesCircle className='closeform' onClick={handleExpanded} />
          </div>
          <div className='form__wrapper'>
            <AddSiteForm onSiteSubmit={newSiteHandler} />
          </div>
        </DrawerNavigation>
        {loading ? (
          <div style={{ padding: '2rem' }}>Loading...</div>
        ) : (
          <div className='incoming__container'>
            <div className='grid__title__container' style={{ margin: '0', padding: '1rem 1rem 0 1rem' }}>
              <div className='grid__header__background'>
                <div className='grid__title' style={{ color: 'white' }}>
                  Incoming Call: {number}
                </div>
              </div>
            </div>

            <div className='incoming__body'>
              <div className='incoming__column incoming__column--client'>
                <div className='incoming__section'>
                  <AccountForm
                    incomingLayout={true}
                    phoneNumber={number}
                    mode={newClient ? 'add' : 'edit'}
                    id={formState.clientId}
                    setClientId={setClientId}
                    flushBottom
                  />
                </div>
              </div>

              <div className='incoming__column incoming__column--enquiry'>
                <div className='form__wrapper' style={{ padding: '1rem' }}>
                  <div className='form__tabstrip__outer'>
                    <EnquiryAddFields
                      getAndStoreAddressesForCustomer={getAndStoreAddressesForCustomer}
                      getAndStoreContactsForCustomer={getAndStoreContactsForCustomer}
                      clientId={formState.clientId}
                      contactsForClient={contactsForClient}
                      setContactsForClient={setContactsForClient}
                      setContact={setContact}
                      siteAddr={siteAddr}
                      siteData={siteData}
                      setSiteAddr={setSiteAddr}
                      contact={contact}
                      openJobs={formState.openJobs}
                      client={formState.clientName}
                      openEnquiries={formState.openEnquiries}
                      openQuotes={formState.openQuotes}
                      onSiteAddr={formState.siteAddr}
                      onAddSite={handleExpanded}
                      onUpdateEnquiryData={handleEnquiryData}
                      onSubmit={handleSubmit}
                      touchedClient={touchedClient}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='incoming__footer'>
              <button onClick={handleSubmit} className='button__accept'>
                {touchedClient ? 'Update Client & Create Enquiry' : 'Create Enquiry'}
              </button>
            </div>
          </div>
        )}
      </DrawerContent>
    </Drawer>
  )
}

export default Incoming


